

import React from 'react';
import About from '../../Components/About/About';
import Hero from '../../Components/Hero/Hero';
import ContactPage from '../ContactPage/ContactPage';
import Gallery from '../../Components/Gallery/Gallery';
import Rehearsals from '../../Components/Researsals/Rehearsals'; 
import SupportUs from '../../Components/SupportUs/SupportUs';
import Videos from '../../Components/Videos/Videos';
// import Tickets from '../../Components/Tickets/Tickets';
import './HomePage.scss';

export default function HomePage() {
  return (
    <div className="homepage">
      <section id="home" className="home" title="Welcome to Our Theatre" modifier="home">
        <Hero />
      </section>

      <section id="about" className="about" title="About Us" modifier="about">
        <About />
      </section>
 <section id="videos" className="about" title="About Us" modifier="videos">
        <Videos />
      </section>

      {/* <section id="tickets" className="tickets" title="Tickets" modifier="tickets">
        <Tickets />
      </section> */}

      <section id="rehearsals" className="rehearsals" title="Rehearsals" modifier="rehearsals">
        <Rehearsals />
      </section>

      <section id="gallery" className="gallery" title="Gallery" modifier="gallery">
        <Gallery />
      </section>

      <section id="contact" className="contact" title="Contact Us" modifier="contact">
        <ContactPage />
      </section>

      <section id="support" className="support" title="Support Us" modifier="support">
        <SupportUs />
      </section>
    </div>
  );
}